<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="warehouseId" >
        <span slot="label" >
          <a-tooltip>
            仓库ID，外键{extra_warehouse.id}<template slot="title">仓库ID，外键{extra_warehouse.id}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.warehouseId"  :placeholder="$t('请输入')+'仓库ID，外键{extra_warehouse.id}'" />
      </a-form-model-item>
      <a-form-model-item prop="provinceId" >
        <span slot="label" >
          <a-tooltip>
            国家/省份ID(extra_area.area_id)<template slot="title">国家/省份ID(extra_area.area_id)</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.provinceId"  :placeholder="$t('请输入')+'国家/省份ID(extra_area.area_id)'" />
      </a-form-model-item>
      <a-form-model-item prop="province" >
        <span slot="label" >
          <a-tooltip>
            国家/省份名称<template slot="title">国家/省份名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.province" :maxLength="100" :placeholder="$t('请输入')+'国家/省份名称'" />
      </a-form-model-item>
      <a-form-model-item prop="cityId" >
        <span slot="label" >
          <a-tooltip>
            城市ID(extra_area.area_id)<template slot="title">城市ID(extra_area.area_id)</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.cityId"  :placeholder="$t('请输入')+'城市ID(extra_area.area_id)'" />
      </a-form-model-item>
      <a-form-model-item prop="cityTitle" >
        <span slot="label" >
          <a-tooltip>
            城市名称集合<template slot="title">城市名称集合</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.cityTitle" :maxLength="255" :placeholder="$t('请输入')+'城市名称集合'" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            状态 0=禁用，1=启用<template slot="title">状态 0=禁用，1=启用</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWarehouseScope, addWarehouseScope, updateWarehouseScope } from '@/api/warehouse/warehouseScope'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        warehouseId: null,

        provinceId: null,

        province: null,

        cityId: null,

        cityTitle: null,

        status: 0,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        warehouseId: [
          { required: true, message: '仓库ID，外键{extra_warehouse.id}'+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0=禁用，1=启用'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        warehouseId: null,
        provinceId: null,
        province: null,
        cityId: null,
        cityTitle: null,
        status: 0,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWarehouseScope({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateWarehouseScope(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addWarehouseScope(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
